import { render, staticRenderFns } from "./ProductPromoCard.vue?vue&type=template&id=496211fa&scoped=true&lang=pug&"
import script from "./ProductPromoCard.vue?vue&type=script&lang=js&"
export * from "./ProductPromoCard.vue?vue&type=script&lang=js&"
import style0 from "./ProductPromoCard.vue?vue&type=style&index=0&id=496211fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496211fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('496211fa')) {
      api.createRecord('496211fa', component.options)
    } else {
      api.reload('496211fa', component.options)
    }
    module.hot.accept("./ProductPromoCard.vue?vue&type=template&id=496211fa&scoped=true&lang=pug&", function () {
      api.rerender('496211fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/product/bourdain/ProductPromoCard.vue"
export default component.exports